import { LuSearch } from "@/Components/Icons/Icons.jsx";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportInvoiceNumber",
            label: "Invoice Number",
            component: "text-field",
            width: "100%",
            required: true,
          },
        ],
        row2: [
          {
            name: "exportCurrency",
            label: "Currency",
            component: "text-field",
            endpoint: "getExchange",
            labelKey: "label",
            responseKey: "data",
            valueKey: "value",
            type: "autocomplete",
            icon: LuSearch,
            autofillTargets: {
              currencyValue: "rate",
            },
            required: true,
            width: "40%",
          },

          {
            name: "currencyValue",
            label: "Currency Current Value (INR)",
            component: "text-field",
            width: "60%",
            disabled: true,
            sx: { my: 0 },
            isGet: false,
          },
        ],

        row3: [
          {
            name: "exportInvoiceValue",
            label: "Invoice Value",
            component: "text-field",
            width: "100%",
            dataType: "int",
          },
        ],
        row4: [
          {
            name: "exportInvoiceTOI",
            label: "TOI & Place",
            component: "dropdown",
            width: "40%",
            defaultValue: "FOB",
            required: true,
            endIconName: "LuChevronDown",
            options: [
              { label: "FOB", value: "FOB" },
              { label: "CIF", value: "CIF" },
              { label: "C&F", value: "C&F" },
              { label: "C&I", value: "C&I" },
            ],
          },
          {
            name: "exportInvoiceTOIPlace",
            component: "text-field",
            width: "60%",
            required: true,
          },
        ],
        row5: [
          {
            name: "exportInvoicePackingorFob",
            label: "Packing/FOB",
            component: "text-field",
            defaultValue: "1000.00",
            width: "100%",
          },
        ],
        row6: [
          {
            name: "BuyerInfo",
            component: "header",
          },
        ],
        row7: [
          {
            name: "buyerId",
            required : true,
            label: "Name",
            component: "text-field",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              invoiceBuyerAddress: "addressLine",
              invoiceBuyerCity: "city",
              invoiceBuyerState: "state",
              invoiceBuyerCountry: "country",
              invoiceBuyerPincode: "pincode",
            },
            endPointWithId: "getCustomersAddress",
          },
        ],
        row8: [
          {
            name: "invoiceBuyerAddress",
            component: "textarea",
            width : "100%",
            disabled : true,
            sx: {
              minHeight: "10%",
              borderRadius: 10,
            },
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "48%",
      rows: {
        row1: [
          {
            name: "exportInvoiceDate",
            label: "Date",
            component: "dateselector",
            width: "100%",
          },
        ],
        row2: [
          {
            name: "exportinvoicepriceicludes",
            label: "Price Includes",
            component: "dropdown",
            endIconName: "LuChevronDown",
            defaultValue: "None",
            width: "100%",
            options: [
              { label: "None", value: "None" },
              { label: "Freight", value: "Freight" },
              { label: "Insurance", value: "Insurance" },
              { label: "Both", value: "Both" },
            ],
          },
        ],
        row3: [
          {
            name: "exportInvoiceproductvalue",
            label: "Product Value(FOB)",
            component: "text-field",
            width: "100%",
            dataType: "int",
          },
        ],
        row4: [
          {
            name: "exportInvicetaxablevalue",
            label: "Taxable value for IGST",
            component: "text-field",
            endIconName: "LuChevronDown",
            defaultValue: "job1",
            width: "100%",
            dataType: "int",
          },
        ],
        
        row5: [
          {
            name: "invoiceBuyerCity",
            label: "City",
            component: "text-field",
            width: "50%",
            disabled : true,
          },

          {
            name: "invoiceBuyerPincode",
            label: "PIN",
            component: "text-field",
            width: "50%",
            disabled : true,
          },
        ],

        row6: [
          {
            name: "invoiceBuyerCountry",
            label: "Country",
            component: "text-field",
              disabled : true,

          },
        ],
        row7: [
          {
            name: "invoiceBuyerState",
            label: "State",
            component: "text-field",
            disabled : true,

          },
        ],
      },
    },
  ],
};
